/**
 * @module itemCategory
 * @description A list of itemCategory
 */
export const itemCategory = [
	{
		name: 'Accommodation',
		description: 'Hotel, motel room, guest house, airbnb',
	},
	{
		name: 'Office Products',
		description: 'Supplies, Furniture, Printers, Calculators',
	},
	{
		name: 'Bookings',
		description: 'Hotel, motel room, guest house, airbnb',
	},
	{
		name: 'Electronics ',
		description: 'Audio, Video, Camera, Photo, Cell Phone, Car Electronics, Computer, and Office Accessories',
	},
	{
		name: 'Books',
		description: 'Books, Calendars, Card Decks, Sheet Music, Magazines, Journals, Other Publications',
	},
	{
		name: 'Music',
		description: 'CDs, Cassettes, Vinyl, and other sound recordings',
	},
	{
		name: 'Clothing & Accessories',
		description: 'Outerwear, Athletic Wear, Innerwear, Belts, Wallets',
	},
	{
		name: 'Fine Art',
		description: 'Paintings, Drawings, Mixed Media (Two-Dimensional), Limited Edition Prints and Photographs',
	},
	{
		name: 'Historical & Advertising Collectibles',
		description:
			'Vintage collectibles related to historical people, places, or events and promotional materials related to consumer brands. ',
	},
	{
		name: 'Personal Computers',
		description: 'Desktops, Laptops, Drives, Storage',
	},
	{
		name: 'Luggage & Travel Accessories',
		description: 'Luggage, Bags, Backpacks, Briefcases, Umbrellas, Travel Accessories',
	},
	{
		name: 'Health & Personal Care',
		description: 'First Aid, Nutrition. See also Beauty.',
	},
	{
		name: 'Outdoors',
		description: 'Outdoor Gear, Outdoor Sports Apparel, Cycling, and Action Sports',
	},
	{
		name: 'Cell Phones',
		description: 'Phones',
	},
	{
		name: 'Home & Garden',
		description:
			'Kitchen, Dining, Pet Supplies, Furniture, Décor, Bedding, Bath, Craft, Hobby, Home Appliances, Storage, Patio, Lawn, Garden, Pool Supplies, Landscaping, Snow Removal, Generators',
	},
	{
		name: 'Beauty',
		description: 'Fragrance, Skincare, Makeup, Hair Care, Bath & Shower. See also Health & Personal Care',
	},
	{
		name: 'Collectible Coins',
		description:
			'Graded collectible coins minted by governments, US Mint packaged product, gold coins, silver coins, platinum coins, palladium coins',
	},
	{
		name: 'Baby Products ',
		description: 'Nursery, Feeding, Gear',
	},
	{
		name: 'Automotive & Powersports',
		description: 'Parts, Tools & Equipment, Accessories',
	},
	{
		name: 'Grocery & Gourmet Food',
		description: 'Beverages, Breakfast, Canned Goods, Household Supplies, Snacks, Meat, Seafood, Chocolate, Desserts, Gift Baskets',
	},
	{
		name: 'Industrial & Scientific',
		description: 'Lab Equipment & Supplies, Industrial Materials, Power Transmission, Electronic Components, Sanitation, Janitorial',
	},
	{
		name: 'Handmade',
		description: 'Handmade and Hand-altered Products',
	},
	{
		name: 'Software & Computer Games',
		description: "Business, Media Education, Utility, Security, Children's Software and PC Games",
	},
	{
		name: 'Jewelry',
		description: 'Earrings, Necklaces, Rings, Bracelets (see also Watches)',
	},
]
